<template>
  <aside
    class="sidenav navbar navbar-vertical navbar-expand-xs border-0 fixed-start h-100"
    id="sidenav-main"
  >
    <div class="sidenav-header d-flex justify-content-center align-items-center py-4">
      <i
        class="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-lg-block d-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <div class="d-flex align-items-center justify-content-center w-100 mt-3">
        <img
          src="/img/logo_sidebar.webp"
          class="navbar-brand-img"
          alt="logo_sidebar"
          style="height: 64px; width: auto"
        />
      </div>
    </div>
    <div class="collapse navbar-collapse w-auto" id="sidenav-collapse-main">
      <div class="sidebar-menu-divider my-3"></div>
      <ul class="navbar-nav mt-3">
        <li class="nav-item" @click="goToRoute('/overview')">
          <a
            class="nav-link"
            :class="{ active: $route.path.includes('/overview') }"
            style="cursor: pointer; border-radius: 5%/50%; height: 30px"
          >
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Inicio</span
            >
          </a>
        </li>
        <li class="nav-item mt-2" @click="goToRoute('/postulation')">
          <a
            class="nav-link"
            :class="{
              active:
                $route.path.includes('/postulation') ||
                $route.path == '/postulation',
            }"
            style="cursor: pointer; border-radius: 5%/50%; height: 30px"
          >
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Mis postulaciones</span
            >
          </a>
        </li>
        <li class="nav-item mt-2" @click="goToRoute('/my-payments')">
          <a
            class="nav-link"
            :class="{
              active:
                $route.path.includes('/my-payments') ||
                $route.path == '/my-payments',
            }"
            style="cursor: pointer; border-radius: 5%/50%; height: 30px"
          >
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Mis pagos</span
            >
          </a>
        </li>
        <li class="nav-item mt-2" @click="goToRoute('/profile')">
          <a
            class="nav-link"
            :class="{
              active:
                $route.path.includes('/profile') || $route.path == '/profile',
            }"
            style="cursor: pointer; border-radius: 5%/50%; height: 30px"
          >
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Mi perfil</span
            >
          </a>
        </li>
        <li v-if="isTrainerAndFormerPlayer || isTrainer" class="nav-item mt-2" @click="goToURL('https://www.conmebol.com/entrenadores-con-licencia-conmebol/')">
          <a
            class="nav-link"
            style="
              cursor: pointer;
              border-radius: 5%/50%;
              height: 30px;
              width: 232px;
            "
          >
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Conmebol</span
            >
          </a>
        </li>
        <li v-if="isTrainerAndFormerPlayer || isTrainer" class="nav-item mt-2" @click="goToRoute('/rne')">
          <a
            class="nav-link"
            :class="{
              active:
                $route.path.includes('/rne') ||
                $route.path == '/rne',
            }"
            style="
              cursor: pointer;
              border-radius: 5%/50%;
              height: 30px;
              width: 232px;
            "
          >
            <span class="nav-link-text ms-3" style="text-transform: none"
              >RNE</span
            >
          </a>
        </li>
        <li class="nav-item mt-2" @click="closeSession">
          <a
            class="nav-link"
            style="cursor: pointer; border-radius: 5%/50%; height: 30px"
          >
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Cerrar sesión</span
            >
          </a>
        </li>
        <!-- <li  class="nav-item mt-2" @click="goToRoute('/clubs/mydata')">
            <a class="nav-link" :class="{ 'active': $route.path === '/clubs/mydata'}" style="cursor:pointer; border-radius: 5%/50%; height: 30px;">
              <v-icon v-if="$route.path === '/clubs/mydata'" fill="white" name="futbol"></v-icon>
              <v-icon v-else fill="#CCCCCC" name="futbol"></v-icon>
              <span class="nav-link-text ms-3" style="text-transform: none;">Mis Datos</span>
            </a>
          </li>
          <li  class="nav-item mt-2" @click="goToRoute('/clubs/myfile')">
            <a class="nav-link" :class="{ 'active': $route.path === '/clubs/myfile'}" style="cursor:pointer; border-radius: 5%/50%; height: 30px;">
              <v-icon v-if="$route.path === '/clubs/myfile'" fill="white" name="users"></v-icon>
              <v-icon v-else fill="#CCCCCC" name="users"></v-icon>
              <span class="nav-link-text ms-3" style="text-transform: none;">Mis Archivos</span>
            </a>
          </li> -->
      </ul>
    </div>
    <!-- Inicio del footer -->
    <footer
      class="footer align-items-lg-end align-items-xl-end align-items-xxl-end pt-5"
    >
      <div class="container-fluid">
        <div
          class="row align-items-center justify-content-lg-center align-items-lg-end align-items-xl-end align-items-xxl-end"
        >
          <div
            class="col-lg-12 mb-lg-0 mb-0 d-flex flex-column align-items-center"
            style="bottom: 32px !important; position: absolute"
          >
            <img
              src="/img/logo_ticz.png"
              alt="Logo Ticz"
              class="ticz-logo mb-2"
            />
            <a
              href="https://ticz.io/"
              class="ticz-footer-text"
              target="_blank"
              rel="noopener noreferrer"
              >Desarrollado por Ticz</a
            >
          </div>
        </div>
      </div>
    </footer>
  </aside>
</template>
<script>
import { mapActions } from "vuex";
import IconBox3D from "../components/Icons/Box3D";
import IconCreditCard from "../components/Icons/CreditCard";
import IconCustomerSupport from "../components/Icons/CustomerSupport";
import IconOffice from "../components/Icons/Office";
import IconShop from "../components/Icons/Shop";
import IconSpaceShip from "../components/Icons/SpaceShip";
import IconDocument from "../components/Icons/Document";
import Cookies from "js-cookie";

export default {
  components: {
    IconBox3D,
    IconCreditCard,
    IconOffice,
    IconShop,
    IconSpaceShip,
    IconDocument,
    IconCustomerSupport,
  },
  computed: {
    routeName() {
      //const {name} = this.$route
      //return this.capitalizeFirstLetter(name)
    },
    isUser() {
      if(this.id_type_user == 0){
        return true;
      }else{
        return false;
      }
    },
    isTrainer() {
      if(this.id_type_user == 1){
        return true;
      }else{
        return false;
      }
    },
    isFormerPlayer() {
      if(this.id_type_user == 2){
        return true;
      }else{
        return false;
      }
    },
    isTrainerAndFormerPlayer() {
      if(this.id_type_user == 3){
        return true;
      }else{
        return false;
      }
    },

  },
  data() {
    return {
      activeNotifications: false,
      id_type_user: Cookies.get("id_type_user"),
    };
  },
  methods: {
    ...mapActions(["logout"]),
    goToRoute(route) {
      this.$router.push(route);
      //this.$router.push('/admin/overview')
    },
    goToURL(url) {
      window.open(url, "_blank");
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    closeSession() {
      console.log("Bye Bye");
      this.logout();
      location.reload();
    },
  },
};
</script>
<style scoped>
.navbar-vertical.navbar-expand-xs .navbar-collapse {
  display: block;
  overflow: auto;
  height: max-content !important;
}
</style>

<style>
aside {
  position: fixed;
  top: 0;
  bottom: 0;
  left: -300px;
  width: 300px;
  transition: all 0.3s ease;
}

aside#sidenav-main {
  background-color: #47162a !important;
  margin: 0 !important;
  border-radius: 0 !important;
}

@media only screen and (max-width: 767px) {
  aside {
    left: 0;
    width: 100%;
  }

  aside.show {
    z-index: 999;
  }
}

.navbar-vertical .navbar-nav > .nav-item .nav-link.active {
  color: #47162a !important;
  background-color: #e7e7e7 !important;
  border-radius: 999px;
}
.navbar-vertical .navbar-nav .nav-link {
  color: #ffffff99 !important;
  background-color: transparent !important;
}
.navbar-vertical .navbar-nav .nav-link .nav-link-text {
  color: inherit;
}

.navbar-vertical .navbar-nav .nav-item {
  margin-bottom: 0.35rem;
}

.sidebar-menu-divider {
  height: 0;
  margin: 0 1.5rem;
  border: 0;
  border-top: 1.5px solid;
  border-image-source: linear-gradient(
    90deg,
    rgba(224, 225, 226, 0) 0%,
    #e0e1e2 49.99%,
    rgba(224, 225, 226, 0.15625) 99.04%
  );
  border-image-slice: 1;
}
.ticz-logo {
  height: 40px;
  width: auto;
  filter: brightness(0) invert(1);
}
.ticz-footer-text {
  color: #ffffff;
  font-size: 14px;
  text-transform: none;
  transition: color 0.3s ease-out;
}

.ticz-footer-text:hover {
  background-image: linear-gradient(90deg, #b49b57, #f5e3a1);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: -100% 50%;
  animation: ticzHoverPaint 0.7s forwards;
}

@keyframes ticzHoverPaint {
  0% {
    background-position: -100% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}
</style>
